import { render, staticRenderFns } from "./rec_fbi_cde.vue?vue&type=template&id=60c495c1&scoped=true&"
import script from "./rec_fbi_cde.vue?vue&type=script&lang=js&"
export * from "./rec_fbi_cde.vue?vue&type=script&lang=js&"
import style0 from "./rec_fbi_cde.vue?vue&type=style&index=0&id=60c495c1&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60c495c1",
  null
  
)

export default component.exports